import React, { useState, useEffect } from "react";

import { Form } from "react-bootstrap";

// import validator from 'validator'

// import 'react-phone-number-input/style.css';
// import PhoneInput from 'react-phone-number-input';
import { isValidPhoneNumber } from "react-phone-number-input";

import PhoneInput from "react-phone-input-2";
// import { isValidPhoneNumber } from 'react-phone-input-2'
import "react-phone-input-2/lib/style.css";

const PhoneNumbers = ({ book, phoneBookChange }) => {
  const [inputList, setInputList] = useState(book);

  const [value, setValue] = useState();
  const [valid, setValid] = useState(true);

  // Handle for phone number change
  const handleInputChange = (value, data, event, formattedValue, index) => {
    // console.log(value);
    // console.log(data);
    // console.log(event);
    // console.log(formattedValue);
    // console.log(index);
    //

    // console.log(isValidPhoneNumber(formattedValue));

    // Eliminiamo il 39 del prefisso
    const str = value.substring(2);
    if (str.length !== 0) {
      if (isValidPhoneNumber(formattedValue)) {
        // Va usato come array - credo -valid i element
        // setValid(true);
        event.target.setCustomValidity("");
      } else {
        // setValid(false);
        // Settando il valore a NON empty il form NON viene submitted
        event.target.setCustomValidity("Phone number not valid");
      }
    } else {
      // il numero è vuoto - resettiamo il setCustomValidity in modo che possa essere submitted
      event.target.setCustomValidity("");
    }

    const list = [...inputList];
    list[index]["phone"] = formattedValue;
    setInputList(list);
    phoneBookChange(list);
  };

  // Handle for whatsapp checkbox change
  const handleCheckboxChange = (e, index) => {
    const target = e.target;
    const checked = target.checked;

    const list = [...inputList];
    list[index]["whatsapp"] = checked;
    setInputList(list);
    phoneBookChange(list);
  };

  // handle click event of the Remove button
  const handleRemoveClick = (event, index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
    phoneBookChange(list);
  };

  // handle click event of the Add button
  const handleAddClick = (event) => {
    event.preventDefault();

    const list = [...inputList];
    const last = list.slice(-1)[0];

    console.log(last);
    // validatePhoneNumber(last.phone);
    console.log(isValidPhoneNumber(last.phone));

    // console.log(listError);
    // setError([true]);
    // console.log(listError);
    //
    if (isValidPhoneNumber(last.phone)) {
      setValid(true);
      setInputList([...inputList, { phone: "", whatsapp: false }]);
      phoneBookChange([...inputList, { phone: "", whatsapp: false }]);
    } else {
      // const p = document.getElementsByClassName("phone_0");
      // p.classList.add("is-invalid");
      setValid(false);
    }
  };

  const validatePhone = (value, country, countries, hiddenAreaCodes) => {
    // Valid è true o false in base a setValid
    if (valid) {
      return true;
    } else {
      return "Numero non valido";
    }
  };

  return (
    <>
      {inputList.map((x, i) => {
        // console.log(x);
        const phone = x.phone;

        return (
          <div className="col-md-12" key={x.phone}>
            <div className="form-row form-inline">
              <PhoneInput
                inputProps={{
                  name: "phone",
                  id: `phone_${i}`,
                  /** ref: `phone_${i}` **/
                }}
                country={"it"}
                onlyCountries={["it"]}
                placeholder="Enter phone number"
                disableDropdown={true}
                countryCodeEditable={false}
                containerClass="w-auto"
                /** validate={valid} **/
                value={phone}
                isValid={(value, country, countries, hiddenAreaCodes) =>
                  validatePhone(value, country, countries, hiddenAreaCodes)
                }
                onChange={(value, country, e, formattedValue) =>
                  handleInputChange(value, country, e, formattedValue, i)
                }
              />
              <div className="invalid-feedback">
                {" "}
                Numero di telefono non valido.{" "}
              </div>
              <div className="valid-feedback"> Numero di telefono valido. </div>

              <Form.Group>
                <Form.Check
                  className="ml-2"
                  type="checkbox"
                  label="Whatsapp"
                  checked={x.whatsapp}
                  onChange={(event) => handleCheckboxChange(event, i)}
                />
              </Form.Group>

              <div className="btn-box">
                {inputList.length !== 1 && (
                  <button
                    onClick={(event) => {
                      handleRemoveClick(event, i);
                    }}
                    className="btn btn-danger ml-2 btn-sm"
                  >
                    Remove
                  </button>
                )}
              </div>
            </div>
            <div className="mt-2">
              {inputList.length - 1 === i && (
                <button
                  onClick={(event) => {
                    handleAddClick(event);
                  }}
                  className="btn btn-success btn-sm"
                >
                  Add
                </button>
              )}
            </div>
          </div>
        );
      })}
      {/* <div style={{ marginTop: 20 }}>{JSON.stringify(inputList)}</div> */}
    </>
  );
};

export default PhoneNumbers;
